import React, { useRef, useState, useEffect } from 'react';
import { Modal, Button } from '@material-ui/core';
import CircleIcon from '@mui/icons-material/Circle';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import WifiIcon from '@mui/icons-material/Wifi';
import BatteryFullIcon from '@mui/icons-material/BatteryFull';
import CommonGuestLayout from '../../../../../shared/email-services/common-guest-layout/CommonGuestLayout';

const useExternalScroll = (dependencies = []) => {
  const scrollRef = useRef(null);
  const thumbRef = useRef(null);
  const [hasScroll, setHasScroll] = useState(false);

  const handleScroll = (e) => {
    const target = e?.target || scrollRef.current;
    if (!target) return;

    const { scrollTop, scrollHeight, clientHeight } = target;

    if (scrollHeight > clientHeight !== hasScroll) {
      setHasScroll(scrollHeight > clientHeight);
    }

    if (!thumbRef.current) return;

    const trackHeight = clientHeight - 12;
    const thumbHeight = Math.max(20, (clientHeight / scrollHeight) * trackHeight);
    const scrollableRange = scrollHeight - clientHeight;
    const thumbRange = trackHeight - thumbHeight;
    const thumbTop = scrollableRange > 0 ? (scrollTop / scrollableRange) * thumbRange : 0;

    thumbRef.current.style.height = `${thumbHeight}px`;
    thumbRef.current.style.top = `${thumbTop + 6}px`;
  };

  useEffect(() => {
    const timer = setTimeout(handleScroll, 100);
    window.addEventListener('resize', handleScroll);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', handleScroll);
    };
  }, dependencies);

  return { scrollRef, thumbRef, hasScroll, handleScroll };
};

const LayoutPreview = (props) => {
  const { isPreview, setIsPreview, componentsList, getImageAligin, guest } = props;

  const desktopScroll = useExternalScroll([isPreview, componentsList]);
  const mobileScroll = useExternalScroll([isPreview, componentsList]);

  const handleClose = () => {
    setIsPreview(false);
  };
  return (
    <div>
      <Modal open={isPreview} onClose={handleClose} className='layout-preview-modal'>
        <div className='preview-box'>
          <div className='preview-desktop-mobile'>
            <div className='row'>
              <div className='preview-desktop col-md-9'>
                <div className='preview-desktop-header'>
                  <div className='row'>
                    <div className='col-md-1 circle-icon'>
                      <CircleIcon className='icon' />
                    </div>
                    <div className='col-md-1 circle-icon'>
                      <CircleIcon className='icon' />
                    </div>
                    <div className='col-md-1 circle-icon'>
                      <CircleIcon className='icon' />
                    </div>
                    <div className='col-md-9'>
                      <p className='header-title'>Check-in Confirmation Email - Desktop Preview</p>
                    </div>
                  </div>
                  <div
                    className='preview-desktop-body-wrapper-outer'
                    style={{ position: 'relative' }}
                  >
                    <div
                      className='preview-desktop-body-wrapper'
                      style={{
                        height: 500,
                        overflow: 'hidden',
                        border: '1px solid #e0e0e0',
                        borderRadius: 4,
                        marginTop: 10,
                      }}
                    >
                      <div
                        ref={desktopScroll.scrollRef}
                        onScroll={desktopScroll.handleScroll}
                        className='preview-desktop-body'
                        style={{
                          height: '100%',
                          overflowY: 'auto',
                          overflowX: 'hidden',
                          scrollbarWidth: 'none',
                          msOverflowStyle: 'none',
                        }}
                      >
                        <style>{`
                          .preview-desktop-body, .preview-desktop-body * {
                            scrollbar-width: none !important;
                            -ms-overflow-style: none !important;
                          }
                          .preview-desktop-body::-webkit-scrollbar, 
                          .preview-desktop-body *::-webkit-scrollbar {
                            display: none !important;
                            width: 0 !important;
                            height: 0 !important;
                          }
                        `}</style>
                        <div className='email-address'>
                          <span className='email-address-text'>To:</span>
                        </div>
                        <div className='email-address'>
                          <span className='email-address-text'>From:</span>
                          {guest.fromAddess}
                        </div>
                        <div className='email-address'>
                          <span className='email-address-text'>Subject:</span>
                          {guest.subject}
                        </div>
                        <CommonGuestLayout
                          componentsList={componentsList}
                          getImageAligin={getImageAligin}
                          isPreview={true}
                          isMobilePreview={false}
                        />
                      </div>
                    </div>
                    {desktopScroll.hasScroll && (
                      <div
                        className='email-preview-scrollbar-desktop'
                        style={{ top: '15px', bottom: '5px', right: '-12px' }}
                      >
                        <div
                          ref={desktopScroll.thumbRef}
                          className='email-preview-scrollbar-thumb-desktop'
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className='preview-desktop col-md-3'>
                <div className='preview-desktop-header'>
                  <p className='header-title'>Mobile Preview</p>
                  <div
                    className='preview-desktop-body-wrapper-outer'
                    style={{ position: 'relative' }}
                  >
                    <div
                      className='preview-desktop-body-wrapper'
                      style={{
                        height: 500,
                        overflow: 'hidden',
                        border: '1px solid #e0e0e0',
                        borderRadius: 4,
                        marginTop: 10,
                      }}
                    >
                      <div
                        ref={mobileScroll.scrollRef}
                        onScroll={mobileScroll.handleScroll}
                        className='preview-desktop-body'
                        style={{
                          height: '100%',
                          overflowY: 'auto',
                          overflowX: 'hidden',
                          scrollbarWidth: 'none',
                          msOverflowStyle: 'none',
                        }}
                      >
                        <style>{`
                          .preview-desktop-body, .preview-desktop-body * {
                            scrollbar-width: none !important;
                            -ms-overflow-style: none !important;
                          }
                          .preview-desktop-body::-webkit-scrollbar, 
                          .preview-desktop-body *::-webkit-scrollbar {
                            display: none !important;
                            width: 0 !important;
                            height: 0 !important;
                          }
                        `}</style>
                        <div className='email-address d-flex justify-content-between'>
                          <div className='col-md-8'>9:41</div>
                          <div className='col-md-1'>
                            <SignalCellularAltIcon className='mobile-icon' />
                          </div>
                          <div className='col-md-1'>
                            <WifiIcon className='mobile-icon' />
                          </div>
                          <div className='col-md-1'>
                            <BatteryFullIcon className='rotate-battery mobile-icon' />
                          </div>
                        </div>
                        <div className='email-address'>
                          <span className='email-address-text'>To:</span>
                        </div>
                        <div className='email-address'>
                          <span className='email-address-text'>From:</span>
                          {guest.fromAddess}
                        </div>
                        <div className='email-address'>
                          <span className='email-address-text'>Subject:</span>
                          {guest.subject}
                        </div>
                        <CommonGuestLayout
                          componentsList={componentsList}
                          getImageAligin={getImageAligin}
                          isPreview={true}
                          isMobilePreview={true}
                        />
                      </div>
                    </div>
                    {mobileScroll.hasScroll && (
                      <div
                        className='email-preview-scrollbar-mobile'
                        style={{ top: '15px', bottom: '5px', right: '-12px' }}
                      >
                        <div
                          ref={mobileScroll.thumbRef}
                          className='email-preview-scrollbar-thumb-mobile'
                        />
                      </div>
                    )}
                  </div>
                  <div className='btn-close-email-preview'>
                    <Button
                      variant='outlined'
                      type='button'
                      color='secondary'
                      size='large'
                      onClick={(e) => handleClose(e)}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default LayoutPreview;
